import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PlayArrow from '@material-ui/icons/PlayArrow';
import Check from '@material-ui/icons/Check';
import Cancel from '@material-ui/icons/Cancel';
import Warning from '@material-ui/icons/Warning';
import Send from '@material-ui/icons/Send';
import FindInPage from '@material-ui/icons/FindInPage';
import AttachMoney from '@material-ui/icons/AttachMoney';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Backdrop from '@material-ui/core/Backdrop';
import FloatingActionButton from '../FloatingActionButton/index';
import { SketchOrderStatus } from '../../lib/sketchOrderStatuses';

class TransitionSketchOrderButton extends Component {
    state = {
        menuOpen: false,
        anchorEl: null,
    };

    getButtonContext = () => {
        switch (this.props.currentStatus) {
            case SketchOrderStatus.RevisionRequested:
            case SketchOrderStatus.Pending:
            case SketchOrderStatus.Queued:
                return {
                    text: 'Start',
                    icon: <PlayArrow />,
                };
            case SketchOrderStatus.InProgress:
                return {
                    text: 'Submit',
                    icon: <Send />,
                };
            case SketchOrderStatus.PendingReview:
                return {
                    text: 'Start',
                    icon: <PlayArrow />,
                };
            case SketchOrderStatus.InReview:
            case SketchOrderStatus.BillingFailed:
                return {
                    text: 'Complete',
                    icon: <Check />,
                };
            case SketchOrderStatus.PendingGroupBilling:
            case SketchOrderStatus.Complete:
                return {
                    text: 'Mark as Billed',
                    icon: <AttachMoney />,
                };
            case SketchOrderStatus.PendingRejection:
                return {
                    text: 'Reject',
                    icon: <Cancel />,
                };
            case SketchOrderStatus.Incomplete:
                return {
                    text: 'Mark Needs Attention',
                    icon: <Warning />,
                };
            case SketchOrderStatus.Exception:
                return {
                    text: 'Send',
                    icon: <Send />,
                };
            default:
                return {
                    text: 'Update',
                };
        }
    };

    handleButtonClick = (event) => {
        const { allowedStatusTransitions } = this.props;

        if (
            !allowedStatusTransitions ||
            allowedStatusTransitions.length === 0
        ) {
            return;
        }

        if (allowedStatusTransitions.length === 1) {
            const status = allowedStatusTransitions[0];
            this.props.onClick(status);
        } else {
            this.setState({
                anchorEl: event.currentTarget,
                menuOpen: true,
            });
        }
    };

    handleMenuItemClick = (status) => {
        this.setState({
            anchorEl: null,
            menuOpen: false,
        });
        this.props.onClick(status);
    };

    handleClose = () => {
        this.setState({ menuOpen: false, anchorEl: null });
    };

    getMenuItemContext = (status) => {
        switch (status) {
            case SketchOrderStatus.Queued:
                return {
                    text: 'Send to Queue',
                    icon: <Send />,
                };
            case SketchOrderStatus.InProgress:
                return {
                    text: 'Send to In Progress',
                    icon: <Send />,
                };
            case SketchOrderStatus.Complete:
                return {
                    text: 'Complete',
                    icon: <Check />,
                };
            case SketchOrderStatus.PendingReview:
                return {
                    text: 'Submit for Review',
                    icon: <FindInPage />,
                };
            case SketchOrderStatus.PendingRejection:
                return {
                    text: 'Submit for Rejection',
                    icon: <Cancel />,
                };
            case SketchOrderStatus.Incomplete:
                return {
                    text: 'Reject',
                    icon: <Cancel />,
                };
            case SketchOrderStatus.Exception:
                return {
                    text: 'Mark Needs Attention',
                    icon: <Warning />,
                };
            case SketchOrderStatus.Cancelled:
                return {
                    text: 'Cancel',
                    icon: <Cancel />,
                };
            case SketchOrderStatus.InReview:
                return {
                    text: 'Send to In Review',
                    icon: <Send />,
                };
            default:
                return {
                    text: `Move to ${status}`,
                };
        }
    };

    renderMenuItems = (status) => {
        const menuItemContext = this.getMenuItemContext(status);
        return (
            <MenuItem
                key={status}
                button
                onClick={() => this.handleMenuItemClick(status)}
            >
                {menuItemContext.icon && (
                    <ListItemIcon>{menuItemContext.icon}</ListItemIcon>
                )}
                <ListItemText primary={menuItemContext.text} />
            </MenuItem>
        );
    };

    renderBackdropComponent = () => (
        <Backdrop open={this.state.menuOpen} onClick={this.handleClose} />
    );

    render() {
        const context = this.getButtonContext();
        return (
            this.props.allowedStatusTransitions &&
            this.props.allowedStatusTransitions.length > 0 && (
                <React.Fragment>
                    <FloatingActionButton
                        aria-owns={this.state.anchorEl ? 'menu' : null}
                        aria-haspopup='true'
                        text={context.text}
                        icon={context.icon}
                        onClick={this.handleButtonClick}
                        disabled={this.props.disabled}
                        styleOverride={this.props.buttonStyle}
                    />

                    <Menu
                        id='simple-menu'
                        anchorEl={this.state.anchorEl}
                        open={this.state.menuOpen}
                        onClose={this.handleClose}
                        BackdropComponent={this.renderBackdropComponent}
                        PaperProps={{
                            square: true,
                        }}
                    >
                        {this.props.allowedStatusTransitions.map(
                            this.renderMenuItems,
                        )}
                    </Menu>
                </React.Fragment>
            )
        );
    }
}

TransitionSketchOrderButton.propTypes = {
    currentStatus: PropTypes.string.isRequired,
    allowedStatusTransitions: PropTypes.arrayOf(PropTypes.string),
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    buttonStyle: PropTypes.shape({}),
};

TransitionSketchOrderButton.defaultProps = {
    allowedStatusTransitions: [],
    disabled: false,
    buttonStyle: null,
};

export default TransitionSketchOrderButton;
